var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDotsGradient = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 311,
  height: 253,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  opacity: 0.8
}, /*#__PURE__*/React.createElement("mask", {
  id: "dots-gradient_svg__a",
  width: 311,
  height: 265,
  x: 0,
  y: -12,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#C33579",
  strokeWidth: 4,
  d: "M258.579-1.731h20.686M269.507 7.63V-12M258.579 47.343h20.686M269.507 56.704v-19.63M206.863 47.343h20.686M217.792 56.704v-19.63M258.579 96.417h20.686M269.507 105.778v-19.63M206.863 96.417h20.686M217.792 105.778v-19.63M206.863-1.731h20.686M217.792 7.63V-12M258.579 145.491h20.686M269.507 154.852v-19.63M258.579 194.565h20.686M269.507 203.926v-19.63M206.863 194.565h20.686M217.792 203.926v-19.63M258.579 243.639h20.686M269.507 253v-19.63M206.863 243.639h20.686M217.792 253v-19.63M206.863 145.491h20.686M217.792 154.852v-19.63M155.147-1.731h20.687M166.076 7.63V-12M155.147 47.343h20.687M166.076 56.704v-19.63M103.432 47.343h20.686M114.36 56.704v-19.63M155.147 96.417h20.687M166.076 105.778v-19.63M103.432 96.417h20.686M114.36 105.778v-19.63M103.432-1.731h20.686M114.36 7.63V-12M155.147 145.491h20.687M166.076 154.852v-19.63M155.147 194.565h20.687M166.076 203.926v-19.63M103.432 194.565h20.686M114.36 203.926v-19.63M155.147 243.639h20.687M166.076 253v-19.63M103.432 243.639h20.686M114.36 253v-19.63M103.432 145.491h20.686M114.36 154.852v-19.63M51.716-1.731h20.686M62.645 7.63V-12M51.716 47.343h20.686M62.645 56.704v-19.63M0 47.343h20.686M10.929 56.704v-19.63M51.716 96.417h20.686M62.645 105.778v-19.63M0 96.417h20.686M10.929 105.778v-19.63M0-1.731h20.686M10.929 7.63V-12M51.716 145.491h20.686M62.645 154.852v-19.63M51.716 194.565h20.686M62.645 203.926v-19.63M0 194.565h20.686M10.929 203.926v-19.63M51.716 243.639h20.686M62.645 253v-19.63M0 243.639h20.686M10.929 253v-19.63M0 145.491h20.686M10.929 154.852v-19.63"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#dots-gradient_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#dots-gradient_svg__b)",
  d: "M241.875 130.441c0-52.081-39.973-95.443-91.882-99.67l-690.85-56.266V1222.32c0 52.37 40.398 95.86 92.621 99.73l690.111 51.07z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "dots-gradient_svg__b",
  x1: -149.491,
  x2: 241.394,
  y1: -25.495,
  y2: 395.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#2FB2DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#196077"
})))));
export default SvgDotsGradient;